module.exports = __webpack_public_path__ + "img/calculators.9f534d5.jpg";